<script lang="ts" setup>
import { getMetaTags } from '~/utils/meta'
import type { BreadcrumbItem } from '@nuxt/ui'
import { heroImages } from '#shared/models/images'
import type { ResponsiveImageProps } from '~/types/images.ts'

definePageMeta({
  layout: false
})

defineRouteRules({
  prerender: true
})

const { t, baseKey } = useI18n('pages.static.vragen')

const heroImage: ResponsiveImageProps = {
  src: {
    mobile: heroImages['app-contact'].src,
    desktop: heroImages['gabriella-en-sanne'].src
  },
  alt: {
    mobile: heroImages['app-contact'].alt,
    desktop: heroImages['gabriella-en-sanne'].alt
  }
}

useSeoMeta(
  getMetaTags(
    {
      title: '.meta.title',
      description: '.meta.description'
    },
    heroImage.src,
    baseKey
  )
)

useSchemaOrg([
  ...getSchemaOrg(
    {
      title: '.title',
      type: 'FAQPage',
      breadcrumbs: [{ name: '.title' }]
    },
    baseKey
  ),
  defineQuestion({
    name: t('.faq.foodie.questions.0.label'),
    acceptedAnswer: t('.faq.foodie.questions.0.answer')
  }),
  defineQuestion({
    name: t('.faq.foodie.questions.1.label'),
    acceptedAnswer: t('.faq.foodie.questions.1.answer')
  }),
  defineQuestion({
    name: t('.faq.foodie.questions.2.label'),
    acceptedAnswer: t('.faq.foodie.questions.2.answer')
  }),
  defineQuestion({
    name: t('.faq.foodie.questions.4.label'),
    acceptedAnswer: t('.faq.foodie.questions.4.answer')
  }),
  defineQuestion({
    name: t('.faq.foodie.questions.5.label'),
    acceptedAnswer: t('.faq.foodie.questions.5.answer')
  })
])

const breadcrumbItems: BreadcrumbItem[] = [{ label: '.title', to: 'vragen' }]
</script>

<template>
  <div>
    <NuxtLayout
      name="default"
      title=".title"
      description=".description"
      :image="heroImage"
    >
      <VBreadcrumb :items="breadcrumbItems" />

      <VSection
        title=".section-one.title"
        description=".section-one.description"
        title-type="h1"
      >
        <template #after>
          <div class="section-button">
            <VButton
              to="mailto:info@thuisgekookt.nl"
              border
              color="transparent"
              label="info@thuisgekookt.nl"
            />
          </div>
          <div class="section-button">
            <VButton
              to="tel:085-0608768"
              border
              color="transparent"
              label="085-0608768"
            />
          </div>

          <div class="mt-8">
            <SocialMediaIcons />
          </div>
        </template>
      </VSection>

      <FAQSection
        base-key=".faq.foodie"
        title=".title"
        questions=".questions"
        hide-button
      />

      <FAQSection
        base-key=".faq.cook"
        title=".title"
        questions=".questions"
        hide-button
      />

      <FAQSection
        base-key=".faq.donations"
        title=".title"
        questions=".questions"
        hide-button
      />
    </NuxtLayout>
  </div>
</template>

<style scoped></style>
